module.exports = __webpack_public_path__ + "754e99ac82b92d7de95a081c51338251.png";